import { render } from "./AchievementDetailView.vue?vue&type=template&id=96f02f04&ts=true"
import script from "./AchievementDetailView.vue?vue&type=script&lang=ts"
export * from "./AchievementDetailView.vue?vue&type=script&lang=ts"

import "./AchievementDetailView.vue?vue&type=style&index=0&id=96f02f04&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__